module.exports = __webpack_public_path__ + "static/img/cjhg.d5bc3ef.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sy/cjhg.png
// module id = WoYz
// module chunks = 182